import React, { type ComponentProps, useMemo } from 'react';
import { Tabs } from 'expo-router';
import { useResponsive } from '@sg/garnish';

import { Navbar } from '../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function TabsLayout() {
  const { currentBreakpoint } = useResponsive();

  // ─────────────────────────────────────────────────────────────────────

  const screenOptions = useMemo<TabsScreenOptions>(
    () => ({
      headerShown: !currentBreakpoint.isXS,
      header: renderNavbar,
    }),
    [currentBreakpoint.isXS],
  );

  // ─────────────────────────────────────────────────────────────────────

  return <Tabs screenOptions={screenOptions} tabBar={hideTabBar} />;
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

function renderNavbar() {
  return <Navbar />;
}

function hideTabBar() {
  return null;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type TabsScreenOptions = NonNullable<
  ComponentProps<typeof Tabs>['screenOptions']
>;
